import { gql } from "@apollo/client";

export const SALES_QUERIES = gql`
  query salesQueries {
    monthlyCommission
    weeklyCommission
  }
`;
